// Generic presets
export const FROM_PURCHASED_ASSET_PRESET = "from_purchased_asset";
export const BLANK_PRESET = "blank";
export const NEW_BLANK_PROJECT_PRESET = "new_blank_project";
export const FROM_INSPIRATION_PRESET = "from_inspiration";
export const FROM_INSPIRATION_CONTENT_AS_CURATOR_PRESET =
  "from_inspiration_content_as_curator";
// Quick actions presets

// Product shot preset
export const PRODUCT_SHOT_SMARTPHONE_PRESET = "product_shot_smartphone";
export const PRODUCT_SHOT_SIMPLE_STUDIO_SHOT_PRESET =
  "product_shot_simple_studio_shot";
export const PRODUCT_SHOT_EXTERIOR_SHOT_PRESET = "product_shot_exterior_shot";
export const PRODUCT_SHOT_COLOR_VARIANT_SHOT_PRESET =
  "product_shot_color_variant_shot";
export const PRODUCT_SHOT_3D_OBJECT_STUDIO_PRESET =
  "product_shot_3d_object_studio";
export const PRODUCT_SHOT_3D_TOTE_BAG_STUDIO_PRESET =
  "product_shot_3d_tote_bag_studio";
export const PRODUCT_SHOT_UPSCALE_PRESET = "product_shot_upscale";
export const PRODUCT_SHOT_EXPAND_PRESET = "product_shot_expand";
export const PRODUCT_SHOT_DIEGO_JACKET_SHOT_PRESET =
  "product_shot_diego_jacket_shot";
export const PRODUCT_SHOT_GLASSES_SHOT_PRESET = "product_shot_glasses_shot";
export const PRODUCT_SHOT_GLASSES_NEW_YORK_ELECTRIC_PRESET =
  "product_shot_glasses_new_york_electric";
export const PRODUCT_SHOT_GLASSES_RETRO_PARADISE_PRESET =
  "product_shot_glasses_retro_paradise";

// Outdoor photoshoot presets
export const OUTDOOR_PHOTO_SHOOT_FASHION_EDITORIAL_PRESET =
  "outdoor_photoshoot_fashion_editorial";
export const OUTDOOR_PHOTO_SHOOT_ARCHITECTURE_PRESET =
  "outdoor_photoshoot_architecture";
export const OUTDOOR_PHOTO_SHOOT_OBJECT_WITH_MODEL_SHOWCASE_PRESET =
  "outdoor_photoshoot_object_with_model_showcase";
export const OUTDOOR_PHOTO_MODEL_CITY_PARK_PRESET =
  "outdoor_photoshoot_model_city_park";
export const OUTDOOR_PHOTO_FRIENDS_SUNSET_PRESET =
  "outdoor_photoshoot_friends_sunset";
export const OUTDOOR_PHOTO_PRODUCT_NATURE_TABLE_PRESET =
  "outdoor_photoshoot_product_nature_table";
export const OUTDOOR_PHOTO_SHOES_URBAN_STEPS_PRESET =
  "outdoor_photoshoot_shoes_urban_steps";
export const OUTDOOR_PHOTO_ANIME_BEACH_PRESET =
  "outdoor_photoshoot_anime_beach";
export const OUTDOOR_PHOTO_EDIT_SKY_SUNSET_PRESET =
  "outdoor_photoshoot_edit_sky_sunset";
export const OUTDOOR_ILLUSTRATION_WATERCOLOR_FOREST_PRESET =
  "outdoor_illustration_watercolor_forest";
export const OUTDOOR_MOSAIC_LAKE_SUNSET_PRESET =
  "outdoor_illustration_mosaic_lake_sunset";
export const OUTDOOR_PHOTO_EXPAND_PANORAMA_PRESET =
  "outdoor_photoshoot_expand_panorama";
export const OUTDOOR_PHOTO_UPSCALE_PRESET = "outdoor_photoshoot_upscale";

export const MOODBOARD_WARM_COZY_ILLUSTRATION_PRESET =
  "moodboard_warm_cozy_illustration";
export const MOODBOARD_BRAND_COLLECTION_PRESET = "moodboard_brand_collection";
export const MOODBOARD_NEON_NIGHT_PHOTOGRAPHY_PRESET =
  "moodboard_neon_night_photography";
export const MOODBOARD_3D_GEOMETRIC_SHAPES_PRESET =
  "moodboard_3d_geometric_shapes";
export const MOODBOARD_PASTEL_PHOTOS_PRESET = "moodboard_pastel_photos";
export const MOODBOARD_RETRO_VIBES_PRESET = "moodboard_retro_vibes";
export const MOODBOARD_BW_HIGH_CONTRAST_PRESET = "moodboard_bw_high_contrast";
export const MOODBOARD_COLORFUL_LIVELY_PRESET = "moodboard_colorful_lively";
export const MOODBOARD_VINTAGE_SEPIA_PRESET = "moodboard_vintage_sepia";

// Portrait preset
export const PORTRAIT_STUDIO_CLASSIC_PRESET = "portrait_studio_classic";
export const PORTRAIT_URBAN_PRESET = "portrait_urban";
export const PORTRAIT_BLACK_AND_WHITE_PRESET = "portrait_black_and_white";
export const PORTRAIT_WATERCOLOR_PRESET = "portrait_watercolor";
export const PORTRAIT_FISHERMAN_MOSAIC_PRESET = "portrait_fisherman_mosaic";
export const PORTRAIT_DOUBLE_EXPOSURE_PRESET = "portrait_double_exposure";
export const PORTRAIT_JOHN_WHITE_SHIRT_PRESET = "portrait_john_white_shirt";
export const PORTRAIT_ASTRID_RETRO_VIBES_PRESET = "portrait_astrid_retro_vibes";
export const PORTRAIT_HANNAH_FISHEYE_CERAMIC_PRESET =
  "portrait_hannah_fisheye_ceramic";
export const PORTRAIT_BEN_UPSCALE_PRESET = "portrait_ben_upscale";
export const PORTRAIT_JOHN_EXPAND_PRESET = "portrait_john_expand";

// Brand preset
export const BRAND_EXTEND_ICON_BANK_PRESET = "brand_extend_icon_bank";
export const BRAND_MINIMAL_BLUE_LOGO_PRESET = "brand_minimal_blue_logo";
export const BRAND_3D_PAPERWORLD_ICON_PRESET = "brand_3d_paperworld_icon";
export const BRAND_COLLAGE_ICON_PRESET = "brand_collage_icon";
export const BRAND_HERO_SATURATION_PRESET = "brand_hero_saturation";
export const BRAND_PASTEL_OASIS_PATTERN_PRESET = "brand_pastel_oasis_pattern";
export const BRAND_MONO_MOSAIC_BG_PRESET = "brand_mono_mosaic_bg";
export const BRAND_EXPAND_HERO_PRESET = "brand_expand_hero";
export const BRAND_UPSCALE_PRESET = "brand_upscale";

// Stock Photography preset
export const STOCK_BRAINSTORMING_PRESET = "stock_brainstorming";
export const STOCK_WOODSHOP_PRESET = "stock_woodshop";
export const STOCK_URBAN_PRESET = "stock_urban";
export const STOCK_FOREST_PRESET = "stock_forest";
export const STOCK_BREAKFAST_PRESET = "stock_breakfast";
export const STOCK_3D_SHAPES_PRESET = "stock_3d_shapes";
export const STOCK_CARTOON_CHARACTER_PRESET = "stock_cartoon_character";
export const STOCK_BREAKFAST_EDIT_PRESET = "stock_breakfast_edit";
export const STOCK_FOREST_EXPAND_PRESET = "stock_forest_expand";
export const STOCK_CARTOON_BACKGROUND_EDIT_PRESET =
  "stock_cartoon_background_edit";

export const STUDIO_COSMETIC_PRODUCT_PRESET = "cosmetic";
export const STUDIO_FOOD_EDITORIAL_PRESET = "gourmet";
export const STUDIO_OBJECT_STILL_LIFE_PRESET = "object";
export const STUDIO_CHARACTER_PORTRAIT_PRESET = "character";
export const STUDIO_SOFT_FASHION_PRESET = "soft_fashion";
export const STUDIO_EDITORIAL_CHARACTER_PRESET = "editorial_character";
export const STUDIO_PASTEL_OBJECT_PRESET = "pastel_object";
export const STUDIO_NEOPOP_BAG_PRESET = "neopop_bag";
export const STUDIO_SHOES_HYPERREAL_PRESET = "shoes_hyperreal";
export const STUDIO_WATERCOLOR_UNIVERSE_PRESET = "watercolor_universe";
export const STUDIO_CINEMATIC_MONOCHROME_PRESET = "cinematic_monochrome";
export const STUDIO_EXPAND_PRESET = "expand";
export const STUDIO_UPSCALE_PRESET = "upscale";

export const SOCIAL_AD_PRODUCT_PROMO_PRESET = "social_ad_product_promo";
export const SOCIAL_AD_BRIEF_BRAND_CAMPAIGN_PRESET =
  "social_ad_brief_brand_campaign";
export const SOCIAL_AD_STYLE_REF_PRESET = "social_ad_style_ref";
export const SOCIAL_AD_CHARACTER_PRODUCT_REF_PRESET =
  "social_ad_character_product_ref";
export const SOCIAL_AD_EDIT_EXISTING_PRESET = "social_ad_edit_existing";
export const SOCIAL_AD_EXPAND_STORY_PRESET = "social_ad_expand_story";
export const SOCIAL_AD_UPSCALE_HD_PRESET = "social_ad_upscale_hd";

// FIXME: Categorise presets per quick action category to have better code structure
export const STATE_PRESETS = [
  NEW_BLANK_PROJECT_PRESET,
  FROM_PURCHASED_ASSET_PRESET,
  BLANK_PRESET,
  PRODUCT_SHOT_SMARTPHONE_PRESET,
  PRODUCT_SHOT_SIMPLE_STUDIO_SHOT_PRESET,
  PRODUCT_SHOT_EXTERIOR_SHOT_PRESET,
  PRODUCT_SHOT_COLOR_VARIANT_SHOT_PRESET,
  PRODUCT_SHOT_3D_OBJECT_STUDIO_PRESET,
  PRODUCT_SHOT_3D_TOTE_BAG_STUDIO_PRESET,
  PRODUCT_SHOT_DIEGO_JACKET_SHOT_PRESET,
  PRODUCT_SHOT_GLASSES_SHOT_PRESET,
  PRODUCT_SHOT_GLASSES_NEW_YORK_ELECTRIC_PRESET,
  PRODUCT_SHOT_GLASSES_RETRO_PARADISE_PRESET,
  PRODUCT_SHOT_UPSCALE_PRESET,
  PRODUCT_SHOT_EXPAND_PRESET,
  OUTDOOR_PHOTO_SHOOT_FASHION_EDITORIAL_PRESET,
  OUTDOOR_PHOTO_SHOOT_ARCHITECTURE_PRESET,
  OUTDOOR_PHOTO_SHOOT_OBJECT_WITH_MODEL_SHOWCASE_PRESET,
  OUTDOOR_PHOTO_MODEL_CITY_PARK_PRESET,
  OUTDOOR_PHOTO_FRIENDS_SUNSET_PRESET,
  OUTDOOR_PHOTO_PRODUCT_NATURE_TABLE_PRESET,
  OUTDOOR_PHOTO_SHOES_URBAN_STEPS_PRESET,
  OUTDOOR_PHOTO_ANIME_BEACH_PRESET,
  OUTDOOR_PHOTO_EDIT_SKY_SUNSET_PRESET,
  OUTDOOR_ILLUSTRATION_WATERCOLOR_FOREST_PRESET,
  OUTDOOR_MOSAIC_LAKE_SUNSET_PRESET,
  OUTDOOR_PHOTO_EXPAND_PANORAMA_PRESET,
  OUTDOOR_PHOTO_UPSCALE_PRESET,
  MOODBOARD_WARM_COZY_ILLUSTRATION_PRESET,
  MOODBOARD_BRAND_COLLECTION_PRESET,
  MOODBOARD_NEON_NIGHT_PHOTOGRAPHY_PRESET,
  MOODBOARD_3D_GEOMETRIC_SHAPES_PRESET,
  MOODBOARD_PASTEL_PHOTOS_PRESET,
  MOODBOARD_RETRO_VIBES_PRESET,
  MOODBOARD_BW_HIGH_CONTRAST_PRESET,
  MOODBOARD_COLORFUL_LIVELY_PRESET,
  MOODBOARD_VINTAGE_SEPIA_PRESET,
  PORTRAIT_STUDIO_CLASSIC_PRESET,
  PORTRAIT_URBAN_PRESET,
  PORTRAIT_BLACK_AND_WHITE_PRESET,
  PORTRAIT_WATERCOLOR_PRESET,
  PORTRAIT_DOUBLE_EXPOSURE_PRESET,
  PORTRAIT_FISHERMAN_MOSAIC_PRESET,
  PORTRAIT_JOHN_WHITE_SHIRT_PRESET,
  PORTRAIT_ASTRID_RETRO_VIBES_PRESET,
  PORTRAIT_HANNAH_FISHEYE_CERAMIC_PRESET,
  PORTRAIT_BEN_UPSCALE_PRESET,
  PORTRAIT_JOHN_EXPAND_PRESET,
  BRAND_EXTEND_ICON_BANK_PRESET,
  BRAND_MINIMAL_BLUE_LOGO_PRESET,
  BRAND_3D_PAPERWORLD_ICON_PRESET,
  BRAND_COLLAGE_ICON_PRESET,
  BRAND_HERO_SATURATION_PRESET,
  BRAND_PASTEL_OASIS_PATTERN_PRESET,
  BRAND_MONO_MOSAIC_BG_PRESET,
  BRAND_EXPAND_HERO_PRESET,
  BRAND_UPSCALE_PRESET,
  STUDIO_COSMETIC_PRODUCT_PRESET,
  STUDIO_FOOD_EDITORIAL_PRESET,
  STUDIO_OBJECT_STILL_LIFE_PRESET,
  STUDIO_CHARACTER_PORTRAIT_PRESET,
  STUDIO_SOFT_FASHION_PRESET,
  STUDIO_EDITORIAL_CHARACTER_PRESET,
  STUDIO_PASTEL_OBJECT_PRESET,
  STUDIO_NEOPOP_BAG_PRESET,
  STUDIO_SHOES_HYPERREAL_PRESET,
  STUDIO_WATERCOLOR_UNIVERSE_PRESET,
  STUDIO_CINEMATIC_MONOCHROME_PRESET,
  STUDIO_EXPAND_PRESET,
  STUDIO_UPSCALE_PRESET,
  STOCK_3D_SHAPES_PRESET,
  STOCK_BRAINSTORMING_PRESET,
  STOCK_BREAKFAST_EDIT_PRESET,
  STOCK_BREAKFAST_PRESET,
  STOCK_CARTOON_BACKGROUND_EDIT_PRESET,
  STOCK_CARTOON_CHARACTER_PRESET,
  STOCK_FOREST_EXPAND_PRESET,
  STOCK_FOREST_PRESET,
  STOCK_URBAN_PRESET,
  STOCK_WOODSHOP_PRESET,
  SOCIAL_AD_PRODUCT_PROMO_PRESET,
  SOCIAL_AD_BRIEF_BRAND_CAMPAIGN_PRESET,
  SOCIAL_AD_STYLE_REF_PRESET,
  SOCIAL_AD_CHARACTER_PRODUCT_REF_PRESET,
  SOCIAL_AD_EDIT_EXISTING_PRESET,
  SOCIAL_AD_EXPAND_STORY_PRESET,
  SOCIAL_AD_UPSCALE_HD_PRESET,
  FROM_INSPIRATION_PRESET,
  FROM_INSPIRATION_CONTENT_AS_CURATOR_PRESET,
] as const;
